<template>
<div class="container">
        <div class="row justify-content-md-center main">
            <div class="col-12">
                <h1 class="jumbotron-heading">Was kann ich mit dieser Website anstellen?</h1>
                <p class="lead">Diese Website entstand als Projekt für ein Fachschaftszimmer an der Universität Regensburg. In verschiedenen Ecken der
                Uni hängen Monitore, die die Busabfahrtszeiten anzeigen. Das wollten wir auch direkt in unserem Raum haben.
                </p>
                <h2>Raspberry Pi Abfahrtsmonitor</h2>
                <p>Um den Abfahrtsmonitor günstig umzusetzen wurde auf einen alten Monitor und eine Raspberry Pi zurückgegriffen. Das System soll
                  möglichst Fehlerunanfällig sein und mit minimaler Wartung laufen. Deshalb fiel die Entscheidung, Vue also Framework für das Projekt
                  zu nutzen, da durch das aktualisieren der Website das Programm einfach aktuell gehalten werden kann.
                  Raspbian wurde mit einem Service ausgestattet, der die Website beim Start in einem chromium Kioskfenster öffnet.
                </p>
            </div>
        </div>
</div>

</template>
<script>
export default {
  name: 'TechElement',
  components: {
  }
}
</script>

<style scoped>
.main {
    margin-top: 5em;
    display: flex;
    align-items: center;
    text-align: left;
}
</style>
